import React from 'react';
import { Icon, Segment } from 'semantic-ui-react';
import { useIntl } from 'react-intl';

const RemovableCohortFilterValue = ({
  values,
  index,
  onChange,
  children,
}) => {
  const intl = useIntl();
  const removeValue = () => {
    const newValues = [...values];
    newValues.splice(index, 1);
    onChange(newValues);
  };

  return (
    <Segment basic size="mini" className="aridhia-removable-cohort-filter-value p-0 m-auto">
      {children}
      <div style={{ position: 'absolute', top: '0px', left: '4px' }}>
        <Icon
          fitted
          link
          name="delete"
          size="small"
          onClick={removeValue}
          title={intl.formatMessage({ id: 'actions.delete.cohort.filter.value' })}
        />
      </div>
    </Segment>
  );
};

export default RemovableCohortFilterValue;
